import { useMemo } from 'react';

import type { GasInfo } from './types';

import { useGasBalance } from '../../api/gas/useGasBalance';
import { ActivityType } from '../../types/activity';
import { useActivityLog } from '../activity-log';

export type { GasInfo };

export function useGasInfo(): GasInfo {
  const { data: gasBalance, status: gasBalanceStatus } = useGasBalance();
  const { activities, isLoading: activitiesIsLoading } = useActivities();

  const isLoading = gasBalanceStatus === 'loading' || activitiesIsLoading;

  return useMemo(
    () => ({
      gasBalance,
      activities,
      isLoading,
    }),
    [gasBalance, activities, isLoading]
  );
}

const NUM_ACTIVITIES_TO_SHOW = 4;
function useActivities() {
  const { activities: walletActivities, isLoading } = useActivityLog({
    custody: ['wallet', 'external-signer'],
  });
  const mostRecentActivities = walletActivities
    .filter((a) => a.type === ActivityType.GAS)
    .sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1))
    .slice(0, NUM_ACTIVITIES_TO_SHOW);

  return {
    activities: mostRecentActivities,
    isLoading,
  };
}
